export const ACCESS_ENDPOINTS = {
  ME: '/v2/permissions/me',
  SITE_ACCESS: '/v2/permissions/site-access',
} as const;
